import { render, staticRenderFns } from "./AtomSelectPrimaryTimeout.vue?vue&type=template&id=c51470fa&"
import script from "./AtomSelectPrimaryTimeout.vue?vue&type=script&lang=js&"
export * from "./AtomSelectPrimaryTimeout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports